import { render, staticRenderFns } from "./spcodaccountdetail.vue?vue&type=template&id=425d6c80"
import script from "./spcodaccountdetail.vue?vue&type=script&lang=js"
export * from "./spcodaccountdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports